/**
 *
 * @param {String} url
 * @return {boolean}
 */
function isInternalUrl(url: string | undefined): boolean {
    if (url) return url.startsWith('/') || url.startsWith('#');
    return false;
}

function appendToUrlPath(url: string, add: string): string{
    const appendSlash = url => url.endsWith('/') ? url : `${url}/`;
    const appendString = add || '';

    if(!url){
        return '';
    }else if(url.includes('?')){
        const urlArray = url.split('?');

        return `${appendSlash(urlArray[0])}${appendString}?${urlArray[1]}`
    }else if(url.includes('#')){
        const urlArray = url.split('#');
        
        return `${appendSlash(urlArray[0])}${appendString}#${urlArray[1]}`
    }else{
        return `${appendSlash(url)}${appendString}`;
    }
}

export {isInternalUrl, appendToUrlPath};
